import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Helpers from "../../utils/helpers";
import { getActiveOrderProducts } from "./order-review-calculations";
 
const OrderReviewItems = (props: any) => {
 
  const products = getActiveOrderProducts(
    props.orderedItems?.props?.orderinfo?.products || [],
    { includeNegativeAmounts: true }
  );
  const imageBodyTemplate = (rowData: any) => {
    const defaultImage = process.env.PUBLIC_URL + "/assests/images/Desiri-Groundnut-Oils.png";
    const resolvedUrl = rowData.productImageURL || rowData.imageUrl || rowData.url || defaultImage;

    return (
      <img
        src={resolvedUrl}
        alt={rowData.productName}
        onError={(e: any) => {
          e.target.src = defaultImage;
        }}
        style={{ objectFit: 'contain', borderRadius: '4px', width: '50px', height: '50px', display: 'block' }}
      />
    );
  };
 
  const unitPriceBodyTemplate = (rowData: any) => {
    return Helpers.formatAmountInINR(rowData.unitPrice);
  };
 
  const taxableAmountBodyTemplate = (rowData: any) => {
    return Helpers.formatAmountInINR(rowData.amount);
  };
 
  const taxAmountBodyTemplate = (rowData: any) => {
    return Helpers.formatAmountInINR(rowData.tax);
  };
 
  const grossAmountBodyTemplate = (rowData: any) => {
    return Helpers.formatAmountInINR(
      Math.round((rowData.amount || 0) + (rowData.tax || 0) - (rowData.discountAmount || 0))
    );
  };
 
  return (
    <>
      <DataTable
        value={products}  // Use the products array directly
        tableStyle={{ minWidth: "50rem" }}
        size="small"
      >
        <Column
          field="productName"
          style={{ width: "30%" }}
          header="Name"
        ></Column>
        <Column
          header="Image"
          style={{ width: "15%" }}
          body={imageBodyTemplate}
        ></Column>
        <Column
          field="unitPrice"
          header="Price"
          body={unitPriceBodyTemplate}
          bodyStyle={{ textAlign: "right" }}
        ></Column>
        <Column
          field="quantity"
          header="Quantity"
          bodyStyle={{ textAlign: "right" }}
        ></Column>
        <Column
          field="taxableAmount"
          header="Amount"
          body={taxableAmountBodyTemplate}
          bodyStyle={{ textAlign: "right" }}
        ></Column>
        <Column
          field="taxAmount"
          header="Tax"
          body={taxAmountBodyTemplate}
          bodyStyle={{ textAlign: "right" }}
        ></Column>
        <Column
          field="totalAmount"
          header="Total Amount"
          body={grossAmountBodyTemplate}
          bodyStyle={{ textAlign: "right" }}
        ></Column>
      </DataTable>
    </>
  );
};
 
export default OrderReviewItems;